






















import Vue from 'vue'
import CloseButton from '@/components/CloseButton.vue'
export default Vue.extend({
    components: { CloseButton },
    data() {
        return {
            email: '',
            loading: false
        }
    },
    methods: {
        async passwordResetSend(): Promise<void> {
            //  Validate the form
            const valid = await this.$validator.validateAll()

            //  If the form is NOT valid, do nothing
            if (!valid) return

            //  Start the loading spinner
            this.loading = true

            //  Send a password reset email
            const message = await this.$store.dispatch(
                'authPasswordResetEmailSend',
                this.email
            )

            //  Stop the loading spinner
            this.loading = false

            //  If the request failed, do nothing
            if (!message) return

            //  Else, route to home page
            this.$router.push('/')

            //  Notify the user of successful email send
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Password Reset Sent',
                text: `A password reset email has been sent to ${this.email}. Please follow the link to reset your password.`,
                icon: 'mdi-check-circle',
                color: 'primary'
            })
        }
    }
})
